import * as React from "react"
import OutlinedInput from "@mui/material/OutlinedInput"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import ListItemText from "@mui/material/ListItemText"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import { GDPRFilterUserTypes } from "../gdprTypes"
import Checkbox from "@mui/material/Checkbox"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { iterateStringEnum } from "../../../../../../lib/enums"
import { MenuProps } from "../../../../../../shared/components/filters/constants/filterMenuConst"

const useStyles = makeStyles()(() => ({
    selectInput: {
        width: "18.75rem",
    },
}))

export function SelectUserType({
    userTypes,
    setUserTypes,
}: {
    userTypes: string[]
    setUserTypes: React.Dispatch<React.SetStateAction<string[]>>
}) {
    const { l10n } = useAppLocalization()
    const { classes } = useStyles()

    const handleChange = (event: SelectChangeEvent<typeof userTypes>) => {
        const {
            target: { value },
        } = event
        setUserTypes(typeof value === "string" ? value.split(",") : value)
    }

    return (
        <FormControl className={classes.selectInput}>
            <LocalizedStrict id="supplier-account-gdpr-export-user-types-select-input-label">
                <InputLabel id="user-type-select-label">User Types</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="user-type-select-label"
                id="user-type-select"
                multiple
                value={userTypes}
                onChange={handleChange}
                input={<OutlinedInput label="User types" />}
                renderValue={(selected) =>
                    selected
                        .map((value) =>
                            l10n.getStringForEnum("supplier-account-gdpr-export-user-types-select-item", value, ""),
                        )
                        .join(", ")
                }
                MenuProps={MenuProps}
            >
                {[...iterateStringEnum(GDPRFilterUserTypes)].map((name) => (
                    <MenuItem key={name} value={name}>
                        <Checkbox checked={userTypes.indexOf(name) > -1} />
                        <ListItemText
                            primary={l10n.getStringForEnum(
                                "supplier-account-gdpr-export-user-types-select-item",
                                name,
                                "",
                            )}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

